import { render, staticRenderFns } from "./UpdateDates.vue?vue&type=template&id=3b4d2f1e&scoped=true"
import script from "./UpdateDates.vue?vue&type=script&lang=js"
export * from "./UpdateDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d2f1e",
  null
  
)

export default component.exports